import React, { useEffect, useState } from 'react';
import '../styles/Cart.scss';
import View from '../components/View';
// import Search from '../assets/svgs/searchLW.svg';
import Book from '../assets/svgs/agenda.svg';
// import Visa from '../assets/svgs/visa.svg';
// import Lock from '../assets/svgs/lock.svg';
import c from '../helpers/constants';
import CardCheckout from '../components/CardCheckout';
import Button from '../components/Button';
import MobileMenuBottom from '../components/MobileBottomMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getBasket, getDeliveryDates } from '../selectors/Order';
import { addToBasket, clearBasket, placeOrder } from '../actions/Order';
import { fetchCustomer } from '../actions/Customer';
import { getCustomer } from '../selectors/Customer';
import _ from 'lodash';
import history from '../helpers/history';
import { roundNumber } from '../helpers/functions';
import DropDown from '../components/DropDown';

const Cart = () => {
  const orderLines = useSelector(getBasket);
  const dispatch = useDispatch();
  const customer = useSelector(getCustomer);
  const deliveryDates = useSelector(getDeliveryDates);
  const [deliveryDate, setDeliveryDate] = useState('');
  const onDelete = (index: number) => {
    const localOrderLines = orderLines?.filter((o, i) => i !== index);
    dispatch(clearBasket());
    dispatch(addToBasket(localOrderLines));
  };

  const onDashboard = () => {
    history.push(c.APP_ROUTES.DASHBOARD);
  };

  const onPlaceOrder = () => {
    dispatch(placeOrder());
  };

  useEffect(() => {
    dispatch(fetchCustomer());
  }, [dispatch]);

  let totalWithoutVat = 0;

  orderLines?.forEach(o => totalWithoutVat += o.line_price);
  return (
        <View>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-8 orders">
                        <div className="orders__title">
                            <h3>Order Summary</h3>
                        </div>
                        <div className="orders__search">
                            <div className="orders__search__left">
                                <div className="orders__search__left__text">
                                    <p>Your Order</p>
                                </div>
                            </div>
                            <div className="orders__search__right">
                                <p>Total (excl VAT): £{roundNumber(totalWithoutVat)}</p>
                            </div>
                        </div>
                        {orderLines.map((o, i) => <CardCheckout
                            key={i}
                            imageCode={o.product_sku}
                            onDelete={() => onDelete(i)}
                            quality={o.product_quality}
                            category={o.product_type_code_name}
                            linePrice={o.line_price}
                            itemPrice={o.item_price}
                            quantity={o.quantity}
                            length={o.length || 0}
                            width={o?.width || 0}
                            reference={o.line_reference}
                            color={o.colour_full_name}
                        />)}
                    </div>

                    <div className="col-lg-4 payment pb-5">
                        <div className="payment__details">
                            <h4 className="pb-2">Payment Details</h4>
                            <p className="text-grey">
                                If you need to change or update your billing details, please contact
                                us: {customer?.branch_phone}
                            </p>
                        </div>
                        <div className="payment__billing">
                            <h4 className="pb-2">Billing Address</h4>
                            <div className="text-grey">
                                {_.startCase(_.toLower(customer?.NAME))}
                                <br/>
                                {_.startCase(_.toLower(customer?.address_1))}
                                <br/>
                                {_.startCase(_.toLower(customer?.town))}
                                <br/>
                                {_.startCase(_.toLower(customer?.county))}
                                <br/>
                                {customer?.pcode}
                            </div>
                        </div>
                        <div className="payment__delivery">
                            <h4>Delivery Details</h4>
                        </div>
                        <div className="payment__billing">
                            <div className="payment__billing__address">
                                <div className="payment__billing__address__title">
                                    <h4 className="pb-2">Address</h4>
                                </div>
                                <div className="payment__billing__address__link">
                                    <div className="payment__billing__address__link__text">
                                        <p className="text-grey">
                                            <u>Select Different Address</u>
                                        </p>
                                    </div>
                                    <div className="payment__billing__address__link__icon">
                                        <img src={Book} alt="Diary"/>
                                    </div>
                                </div>
                            </div>
                            <p className="text-grey">
                                {_.startCase(_.toLower(customer?.NAME))}
                                <br/>
                                {_.startCase(_.toLower(customer?.address_1))}
                                <br/>
                                {_.startCase(_.toLower(customer?.town))}
                                <br/>
                                {_.startCase(_.toLower(customer?.county))}
                                <br/>
                                {customer?.pcode}
                            </p>
                        </div>
                        <div className="payment__date">
                            <h4>Delivery Date *</h4>
                        </div>
                        <div className="payment__date__info pt-2">
                            <div className="payment__date__info__details">
                                <div className="payment__date__info__details__text">
                                    <DropDown items={deliveryDates?.map(d => ({ label: d, value: d }))} value={deliveryDate} onSelect={(item) => setDeliveryDate(item.value)} />
                                </div>
                                <div className="payment__date__info__details__icon">
                                    <img src={Book} alt="Diary"/>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between pt-5">
                            <div className="">
                                <p>Subtotal Excl VAT</p>
                            </div>
                            <div>£{roundNumber(totalWithoutVat)}</div>
                        </div>
                        <div className="d-flex justify-content-between pt-3">
                            <div className="">
                                <p className="text-grey">VAT (20%)</p>
                            </div>
                            <div className="text-grey">£{roundNumber(totalWithoutVat * 0.2)}</div>
                        </div>
                        <div className="d-flex justify-content-between pt-3">
                            <div className="">
                                <p>
                                    <b>Total</b>
                                </p>
                            </div>
                            <div className="">
                                <p>
                                    <b>£{roundNumber(totalWithoutVat * 1.2)}</b>
                                </p>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <Button size="stretch" onClick={onDashboard} text="Continue Shopping"/>
                        </div>
                        <div className="row mt-4">
                            <Button size="stretch" disabled={!deliveryDate} onClick={onPlaceOrder} text="Place Order"/>
                        </div>
                    </div>
                </div>
            </div>

            <MobileMenuBottom/>

        </View>
  );
};

export default Cart;
